import { render, staticRenderFns } from "./ProductlistdetailsPage.vue?vue&type=template&id=0c14a244"
import script from "./ProductlistdetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductlistdetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports